export const parentRegisterViaSchoolLinkSuccess = ({ parentName, parentEmail, schoolName, fee }) => {
  const subject = "Welcome to Practido – Your Access is Ready!";
  const emailBody = `
Hi <strong>${parentName}</strong>,

<p>Your registration on <strong>Practido - Olympiad Practice App</strong> is successful!</p>

<p>
<strong>School Name:</strong> ${schoolName || "-"}<br>
<strong>Login Email ID:</strong> ${parentEmail}
</p>

<p>Please use your registered email ID and the password you created during registration to log in to the <strong>Practido - Olympiad Practice App</strong>.</p>

<p>Start practicing unlimited questions in <strong>Math, Science, Computers, and English (Classes 1–8)</strong>.</p>

<p>
Because you registered through your school, you’ve also unlocked<br>
<strong>Special Academic Year Offer:</strong> One-time fee of <strong>₹${fee}</strong> per student (valid for this academic year)
</p>

<p><strong>What you get with Practido - Olympiad Practice App:</strong></p>
<ul>
  <li>Unlimited practice in Math, Science, Computers & English (Class 1–8)</li>
  <li>Gamified challenges – trophies, leaderboard, points & rewards</li>
  <li>Challenge your friends – make Olympiad practice exciting and fun</li>
  <li>Instant results & progress tracking</li>
  <li>Check solutions for every question – learn from mistakes instantly</li>
  <li>Anytime, anywhere learning without extra workload</li>
  <li>No waiting for the next book, no running out of material – just practice & improvement</li>
  </ul>

<p><strong>Download Practido - Olympiad Practice App</strong><br/>
Start practicing right away on your phone:</p>

<p>
Android App - <a href="https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice">https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice</a><br/>
iOS App - <a href="https://apps.apple.com/in/app/practido-olympiad-practice/id6746647468">https://apps.apple.com/in/app/practido-olympiad-practice/id6746647468</a>
</p>

<p>We’re excited to support your child’s learning journey.<br/>
If you face any issue, just reply to this email or reach us at <a href="mailto:hello@practido.com">hello@practido.com</a>.</p>

<p>
- Thanks & Regards<br/>
Team Practido (Developed by Naskay)
</p>
  `;

  return { subject, emailBody };
};
